var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableFilterAZ(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=a-z"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 21L6.75 15.75L7.8075 14.6925L12 18.8775L16.1925 14.6925L17.25 15.75L12 21ZM12 3L17.25 8.25L16.1925 9.3075L12 5.1225L7.8075 9.3075L6.75 8.25L12 3Z",
    fill: "#ABB3BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 21L6.75 15.75L7.8075 14.6925L12 18.8775L16.1925 14.6925L17.25 15.75L12 21Z",
    fill: "#0B93E3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableFilterAZ);
export default __webpack_public_path__ + "static/media/table-filter-a-z.d9a13c5f516cfbfea1b7840cb46e5544.svg";
export { ForwardRef as ReactComponent };